import {gql} from '@apollo/client';
import {DocumentNode} from 'graphql';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const ALL_STORABLE_SCHEMAS_QUERY: DocumentNode = gql`
  query AllStorableSchemasQuery @skipAudit @engComponent(name: INVENTORY) {
    ...AllStorableSchemasGraphQL
  }
  ${getFragmentWrapper('AllStorableSchemas').fragment}
`;
